export default __webpack_public_path__ + "static/media/clarity-vvs1.5b15b031.webp";